import gql from 'graphql-tag';

export const BroadcastDetails = gql`
  fragment BroadcastDetails on Broadcast {
    id
    type
    title
    message
    delivery_body
    optional_channels
    mandatory_channels
    recipients {
      total
    }
    created_at
  }
`;

export const AlbumFolderBroadcastSequenceDetails = gql`
  fragment AlbumFolderBroadcastSequenceDetails on AlbumFolderBroadcastSequence {
    id
    album_folder {
      id
      name
      start_date
    }
    broadcast_sequence {
      id
      name
    }
    status
    excluded_recipients(slice: { limit: 999 }) {
      total
      records {
        id
        account {
          id
        }
      }
    }
  }
`;
export const BroadcastSequenceStepDetails = gql`
  fragment BroadcastSequenceStepDetails on BroadcastSequenceStep {
    id
    type
    title
    message
    optional_channels
    event_date_offset {
      offset
      offset_type
    }
    attachments {
      total
    }
    matched_photos_filter
    transaction_items_filter
    display_discount_template_message
  }
`;

export const BroadcastSequenceDetails = gql`
  fragment BroadcastSequenceDetails on BroadcastSequence {
    id
    name
    steps(slice: { limit: 999 }) {
      total
      records {
        ...BroadcastSequenceStepDetails
      }
    }
    album_folder_broadcast_sequences(slice: { limit: 999 }) {
      total
      records {
        ...AlbumFolderBroadcastSequenceDetails
      }
    }
  }
  ${BroadcastSequenceStepDetails}
  ${AlbumFolderBroadcastSequenceDetails}
`;
